<template>
    <div class="sm:flex sm:gap-4 sm:py-4 sm:pl-3 sm:pr-4 bg-white rounded-2xl">
        <img class="sm:w-[48px] sm:h-[48px]" :src="avaratUrl" alt="">
        <div class="sm:flex sm:flex-col sm:gap-[10px]">
            <p class="sm:text-small-size-1 text-main-1">{{ name }}</p>
            <p v-if="title" class="font-medium text-gray_1">{{ title }}</p>
            <p v-if="description" class="" :class="descriptionStype" v-html="description"></p>
        </div>
    </div>
</template>
<script>
export default {
    props: ['avaratUrl', 'name', 'title', 'description', 'descriptionStype'],
    data() {
        return {
        }
    }
}
</script>